module.exports = "<div class=\"q-marg-top-xs-at-md q-marg-horz-xl-til-md q-marg-bottom-xl-til-md\"> <div class=clearfix> <a href=# class=\"base-btn v2-btn purple-btn js-manage-view-modal-open q-pull-right-til-md q-block-at-md q-text-center-at-md\"> <i class=\"fa fa-filter q-icon-marg-right\" aria-hidden=true></i> Filters </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/btnSection.html
// module id = 1142
// module chunks = 1